module.exports = __webpack_public_path__ + "img/song.e10fda99.jpg";